class SwatchSelector extends HTMLElement {
  constructor() {
    super();
    this.initSwatchElements();
  }

  initSwatchElements() {
    this.querySelectorAll(".swatch-element").forEach((element) => {
      element.addEventListener("click", () => this.onSwatchChanged(element));
    });
  }

  onSwatchChanged(swatch) {
    let swatchCode = swatch.id == "swatch-buy" ? "buy" : "subscribe";
    let otherSwatchCode = swatch.id == "swatch-buy" ? "subscribe" : "buy";
    let otherSwatch = document.getElementById("swatch-" + otherSwatchCode);

    const affirmElts = document.getElementsByClassName("affirm-as-low-as");
    const earnBanner = document.getElementsByClassName("lm--product-banner");
    document.getElementById;

    for (let ele of affirmElts) {
      ele.className = `affirm-as-low-as swatch-desc-buy swatch-desc-hide`;
    }

    for (let banner of earnBanner) {
      banner.classList.add("swatch-desc-buy", "swatch-desc-hide");
    }

    swatch.className = "swatch-element";
    otherSwatch.className = "swatch-element unselected";

    const toShow = document.getElementsByClassName("swatch-desc-" + swatchCode);
    const toHide = document.getElementsByClassName(
      "swatch-desc-" + otherSwatchCode
    );

    for (let ele of toShow) {
      ele.className = ele.className.replace(
        "swatch-desc-hide",
        "swatch-desc-show"
      );
    }

    for (let ele of toHide) {
      ele.className = ele.className.replace(
        "swatch-desc-show",
        "swatch-desc-hide"
      );
    }
  }
}

if (!customElements.get("swatch-selector")) {
  customElements.define("swatch-selector", SwatchSelector);
}
